import React from "react";
import { observer } from "mobx-react-lite";
import { Spin } from "antd";
import { useParams } from "react-router-dom";
import IntelligenceFeedPage from "../../products/intel/IntelligenceFeedPage";
import ConceptPage from "../../products/concept/ConceptPage";
import TacticsPage from "../../products/strategy_tool/TacticsPage";
import UserHoldingsPage from "../../products/user_holdings/UserHoldingsPage";
import InstHotspotPage from "../../products/inst_hotspot/InstHotspotPage";
import { normalizeIntelCommentKind } from "../../platform_spaces/space/SpaceType";
import { getStandaloneSpaceId } from "../config";
import { ComingSoonPage } from "./ComingSoonPage";
import { StandaloneProductSubscribeGate } from "./StandaloneProductSubscribeGate";
import { standaloneProductRegistry } from "./StandaloneProductRegistry";
import { slotKeyFromRoutePath } from "./standaloneProductSlots";
import { PageLayoutBridge } from "../../layout/PageLayoutContext";

const TactikProductPage = observer(() => {
  const { segment } = useParams<{ segment: string }>();
  const slotKey = slotKeyFromRoutePath(segment);
  const spaceId = getStandaloneSpaceId();

  if (!slotKey) {
    return <ComingSoonPage />;
  }

  const view = standaloneProductRegistry.viewForSlot(slotKey);

  if (!view || view.status === "loading" || standaloneProductRegistry.loading) {
    return (
      <div className="tactik-product-loading">
        <Spin />
      </div>
    );
  }

  if (view.status === "coming_soon") {
    return <ComingSoonPage />;
  }

  if (!view.module) {
    return <ComingSoonPage />;
  }

  if (view.status === "not_subscribed") {
    return <StandaloneProductSubscribeGate row={view.module} />;
  }

  const mod = view.module;
  const spaceProductId = mod.spaceProductId;

  const renderWithLayout = (node: React.ReactNode) => (
    <>
      <PageLayoutBridge productKind={mod.productKind} />
      {node}
    </>
  );

  if (slotKey === "intel") {
    return renderWithLayout(
      <IntelligenceFeedPage
        spaceId={spaceId}
        spaceProductId={spaceProductId}
        spaceDisplayName={mod.displayName?.trim() || "Tactik"}
        intelCommentKind={normalizeIntelCommentKind(mod.intelCommentKind)}
      />
    );
  }

  if (slotKey === "concept") {
    return renderWithLayout(
      <ConceptPage spaceId={spaceId} spaceProductId={spaceProductId} />
    );
  }

  if (slotKey === "strategy") {
    return renderWithLayout(
      <TacticsPage spaceId={spaceId} spaceProductId={spaceProductId} />
    );
  }

  if (slotKey === "institution") {
    return renderWithLayout(
      <InstHotspotPage spaceId={spaceId} spaceProductId={spaceProductId} />
    );
  }

  if (slotKey === "holdings") {
    return renderWithLayout(<UserHoldingsPage spaceId={spaceId} />);
  }

  return <ComingSoonPage />;
});

export default TactikProductPage;
